import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get additionalCharge
export const getAdditionalCharge = createAsyncThunk(
  "additionalCharge/getAdditionalCharge",
  async (params, { rejectWithValue }) => {
    try {
      const { rowsPerPage, search, sortOrder, pageNo } = params;
      const { data } = await API.getAdditionalCharge({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get all additionalCharge
export const getAllAdditionalCharge = createAsyncThunk(
  "additionalCharge/getAllAdditionalCharge",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAllAdditionalCharge();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get previous
export const getPrevious = createAsyncThunk("additionalCharge/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("additionalCharge/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "additionalCharge/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageAdditionalCharge({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get by id
export const getAdditionalChargeById = createAsyncThunk(
  "additionalCharge/getAdditionalChargeById",
  async (id, { rejectWithValue }) => {
    try {
      const { data } = await API.getAdditionalChargeById(id);

      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// create additionalCharge
export const createAdditionalCharge = createAsyncThunk(
  "additionalCharge/createAdditionalCharge",
  async (params, { rejectWithValue }) => {
    const { name, rate, amount, sign, code, canEdit, isActive } = params;
    try {
      const body = JSON.stringify({ name, rate, amount, sign, code, canEdit, isActive });
      const { data } = await API.createAdditionalCharge(body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);
export const updateAdditionalCharge = createAsyncThunk(
  "additionalCharge/updateAdditionalCharge",
  async (param, { rejectWithValue }) => {
    const { id, values } = param;
    const { name, rate, amount, sign, code, canEdit, isActive } = values;
    try {
      const body = JSON.stringify({ name, rate, amount, sign, code, canEdit, isActive });
      const { data } = await API.updateAdditionalCharge(id, body);
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data);
    }
  }
);

// handle search
export const handleSearch = createAsyncThunk("additionalCharge/handleSearch", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.handleSearch({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
